export enum IceHockeyShotOnTargetAttribute {
  EvenStrength = 809,
  PowerPlay = 810,
  Shorthanded = 811,
  Snap = 954,
  Slap = 955,
  Wrist = 956,
  TipIn = 957,
  Backhand = 958,
  Shovel = 959,
  OneHanded = 960,
  WrapAround = 961,
}
